/**
`colorBlack`

Black
 */
const colorBlack = "hsl(0, 0%, 0%)";

/**
`colorWhite`

White

Other aliases:

- `colorBackgroundBase1`
- `colorBackgroundInput`
- `colorBackgroundWhite`
- `colorBorderNeutralEmphasisHighOnDark`
- `colorBorderOnImageEmphasisHigh`
- `colorBorderOnImageEmphasisHighOnDark`
- `colorIconPrimaryOnDark`
- `colorObjectInput`
- `colorObjectNeutralEmphasisHighOnDark`
- `colorObjectOnImage`
- `colorObjectOnImageOnDark`
- `colorOutlineFocusOnDark`
- `colorTextInverse`
- `colorTextNeutralPrimaryOnDark`
- `colorTextPrimaryOnDark`
 */
const colorWhite = "hsl(0, 0%, 100%)";

/**
`colorGray05`

Gravity Gray 05 (Lightest)

Other aliases:

- `colorBackgroundBase0`
- `colorBackgroundBase2`
- `colorBackgroundLight`
- `colorInk95`
- `colorObjectInactiveEmphasisLow`
- `colorObjectNeutralEmphasisLow`
- `colorObjectNeutralEmphasisNoneHover`
 */
const colorGray05 = "hsl(0, 0%, 96%)";

/**
`colorGray10`

Gravity Gray 10

Other aliases:

- `colorBackgroundBase3`
- `colorBackgroundDisabled`
- `colorBorderNeutralEmphasisHighHoverOnDark`
- `colorBorderSecondary`
- `colorInk90`
- `colorObjectNeutralEmphasisHighHoverOnDark`
- `colorObjectNeutralEmphasisNonePress`
- `colorTextNeutralPrimaryHoverOnDark`
 */
const colorGray10 = "hsl(0, 0%, 91%)";

/**
`colorGray15`

Gravity Gray 15

Other aliases:

- `colorBackgroundBase4`
- `colorBorderDisabled`
- `colorBorderNeutralEmphasisLow`
- `colorBorderNeutralEmphasisMediumPressOnDark`
- `colorBorderPrimary`
- `colorIconSecondaryOnDark`
- `colorInk80`
- `colorObjectNeutralEmphasisHighPressOnDark`
- `colorObjectNeutralEmphasisLowHover`
- `colorTextNeutralPrimaryPressOnDark`
 */
const colorGray15 = "hsl(0, 0%, 83%)";

/**
`colorGray20`

Gravity Gray 20

Other aliases:

- `colorBorderInactive`
- `colorBorderNeutralEmphasisHighPressOnDark`
- `colorObjectInactiveEmphasisMedium`
- `colorObjectNeutralEmphasisMediumPressOnDark`
- `colorTextDisabled`
- `colorTextInactive`
- `colorTextNeutralSecondaryPressOnDark`
 */
const colorGray20 = "hsl(0, 0%, 75%)";

/**
`colorGray25`

Gravity Gray 25

Other aliases:

- `colorBorderNeutralEmphasisLowHover`
- `colorBorderNeutralEmphasisMediumHoverOnDark`
- `colorObjectNeutralEmphasisLowPress`
- `colorObjectNeutralEmphasisMediumHoverOnDark`
- `colorTextNeutralSecondaryHoverOnDark`
 */
const colorGray25 = "hsl(0, 0%, 71%)";

/**
`colorGray35`

Gravity Gray 35

Other aliases:

- `colorBorderDotNeutralOnDark`
- `colorBorderInput`
- `colorBorderNeutralEmphasisLowPress`
- `colorBorderNeutralEmphasisMediumOnDark`
- `colorBorderPrimaryOnDark`
- `colorInk60`
- `colorObjectDotNeutralOnDark`
- `colorObjectNeutralEmphasisMediumOnDark`
- `colorTextNeutralSecondaryOnDark`
- `colorTextPlaceholderOnDark`
- `colorTextSecondaryOnDark`
 */
const colorGray35 = "hsl(0, 0%, 62%)";

/**
`colorGray45`

Gravity Gray 45

Other aliases:

- `colorObjectDotNeutral`
 */
const colorGray45 = "hsl(0, 0%, 51%)";

/**
`colorGray55`

Gravity Gray 55

Other aliases:

- `colorBorderDisabledOnDark`
- `colorBorderNeutralEmphasisMedium`
- `colorIconSecondary`
- `colorInk40`
- `colorObjectNeutralEmphasisMedium`
- `colorTextInputIcons`
- `colorTextInputPlaceholder`
- `colorTextNeutralSecondary`
- `colorTextPlaceholder`
- `colorTextSecondary`
 */
const colorGray55 = "hsl(0, 0%, 43%)";

/**
`colorGray65`

Gravity Gray 65

Other aliases:

- `colorBorderDotNeutral`
- `colorBorderNeutralEmphasisLowPressOnDark`
- `colorBorderNeutralEmphasisMediumHover`
- `colorIconSelectArrowPrimary`
- `colorInk30`
- `colorObjectNeutralEmphasisLowPressOnDark`
- `colorObjectNeutralEmphasisMediumHover`
- `colorTextNeutralSecondaryHover`
 */
const colorGray65 = "hsl(0, 0%, 32%)";

/**
`colorGray75`

Gravity Gray 75

Other aliases:

- `colorBackgroundBase4OnDark`
- `colorBorderInactiveOnDark`
- `colorBorderNeutralEmphasisHighPress`
- `colorBorderNeutralEmphasisLowHoverOnDark`
- `colorBorderNeutralEmphasisMediumPress`
- `colorObjectInactiveEmphasisMediumOnDark`
- `colorObjectNeutralEmphasisHighPress`
- `colorObjectNeutralEmphasisLowHoverOnDark`
- `colorObjectNeutralEmphasisMediumPress`
- `colorTextDisabledOnDark`
- `colorTextInactiveOnDark`
- `colorTextNeutralPrimaryPress`
- `colorTextNeutralSecondaryPress`
 */
const colorGray75 = "hsl(0, 0%, 24%)";

/**
`colorGray80`

Gravity Gray 80

Other aliases:

- `colorBackgroundBase3OnDark`
- `colorBorderNeutralEmphasisLowOnDark`
- `colorBorderSecondaryOnDark`
- `colorObjectNeutralEmphasisNonePressOnDark`
 */
const colorGray80 = "hsl(0, 0%, 21%)";

/**
`colorGray85`

Gravity Gray 85

Other aliases:

- `colorBackgroundBase2OnDark`
- `colorBorderNeutralEmphasisHighHover`
- `colorObjectNeutralEmphasisHighHover`
- `colorObjectNeutralEmphasisLowOnDark`
- `colorObjectNeutralEmphasisNoneHoverOnDark`
- `colorTextNeutralPrimaryHover`
 */
const colorGray85 = "hsl(0, 0%, 16%)";

/**
`colorGray90`

Gravity Gray 90

Other aliases:

- `colorBackgroundBase1OnDark`
- `colorObjectInactiveEmphasisLowOnDark`
- `colorObjectInputOnDark`
 */
const colorGray90 = "hsl(0, 0%, 12%)";

/**
`colorGray95`

Gravity Gray 95 (Darkest)

Other aliases:

- `colorBackgroundBase0OnDark`
- `colorBorderNeutralEmphasisHigh`
- `colorIconPrimary`
- `colorInk10`
- `colorObjectNeutralEmphasisHigh`
- `colorTextInput`
- `colorTextInverseOnDark`
- `colorTextNeutralPrimary`
- `colorTextOnImageInverse`
- `colorTextOnImageInverseOnDark`
- `colorTextPrimary`
 */
const colorGray95 = "hsl(0, 0%, 7%)";

/**
`colorBlue05`

Gravity Blue 05 (Lightest)

Other aliases:

- `colorAccentBlue95`
- `colorBackgroundHighlighted`
- `colorBackgroundInteractiveFocus`
- `colorBackgroundInteractiveHover`
- `colorBackgroundStatusInformational`
- `colorObjectInformationalEmphasisLow`
- `colorObjectInteractiveEmphasisLow`
- `colorObjectInteractiveEmphasisNoneFocus`
- `colorObjectInteractiveEmphasisNoneHover`
 */
const colorBlue05 = "hsl(201, 100%, 96%)";

/**
`colorBlue10`

Gravity Blue 10

Other aliases:

- `colorBackgroundInteractiveActive`
- `colorObjectInformationalEmphasisLowHover`
- `colorObjectInteractiveEmphasisLowHover`
- `colorObjectInteractiveEmphasisNonePress`
 */
const colorBlue10 = "hsl(200, 100%, 90%)";

/**
`colorBlue15`

Gravity Blue 15

Other aliases:

- `colorBorderInteractivePressOnDark`
- `colorObjectInformationalEmphasisLowPress`
- `colorObjectInteractiveEmphasisLowPress`
- `colorTextInformationalPressOnDark`
- `colorTextInteractivePressOnDark`
 */
const colorBlue15 = "hsl(200, 98%, 83%)";

/**
`colorBlue20`

Gravity Blue 20

Other aliases:

- `colorObjectInformationalEmphasisHighPressOnDark`
- `colorObjectInteractiveEmphasisHighPressOnDark`
 */
const colorBlue20 = "hsl(200, 98%, 75%)";

/**
`colorBlue25`

Gravity Blue 25

Other aliases:

- `colorAccentBlue60`
- `colorBorderInteractiveHoverOnDark`
- `colorObjectInformationalEmphasisHighHoverOnDark`
- `colorObjectInteractiveEmphasisHighHoverOnDark`
- `colorTextInformationalHoverOnDark`
- `colorTextInteractiveHoverOnDark`
 */
const colorBlue25 = "hsl(200, 97%, 66%)";

/**
`colorBlue35`

Gravity Blue 35

Other aliases:

- `colorBorderDotInformationalOnDark`
- `colorBorderFocusOnDark`
- `colorBorderInteractiveOnDark`
- `colorObjectDotInformationalOnDark`
- `colorObjectInformationalEmphasisHighOnDark`
- `colorObjectInteractiveEmphasisHighOnDark`
- `colorTextInformationalOnDark`
- `colorTextInteractiveOnDark`
 */
const colorBlue35 = "hsl(200, 79%, 54%)";

/**
`colorBlue45`

Gravity Blue 45

Other aliases:

- `colorAccentBlue35`
- `colorBorderInputChecked`
- `colorBorderInputFocus`
- `colorBorderInputHover`
- `colorBorderInteractive`
- `colorBorderStatusInformational`
- `colorIconStatusInformational`
- `colorObjectDotInformational`
 */
const colorBlue45 = "hsl(200, 82%, 42%)";

/**
`colorBlue55`

Gravity Blue 55

Other aliases:

- `colorAccentBlue30`
- `colorBorderFocus`
- `colorBorderInteractive`
- `colorBorderInteractiveFocus`
- `colorBorderInteractiveHover`
- `colorObjectInformationalEmphasisHigh`
- `colorObjectInteractiveEmphasisHigh`
- `colorOutlineFocus`
- `colorTextInformational`
- `colorTextInteractive`
 */
const colorBlue55 = "hsl(200, 100%, 33%)";

/**
`colorBlue65`

Gravity Blue 65

Other aliases:

- `colorAccentBlue25`
- `colorBorderDotInformational`
- `colorBorderInputActive`
- `colorBorderInteractiveActive`
- `colorBorderInteractiveHover`
- `colorObjectInformationalEmphasisHighHover`
- `colorObjectInteractiveEmphasisHighHover`
- `colorTextInformationalHover`
- `colorTextInteractiveActive`
- `colorTextInteractiveFocus`
- `colorTextInteractiveHover`
 */
const colorBlue65 = "hsl(200, 98%, 26%)";

/**
`colorBlue75`

Gravity Blue 75

Other aliases:

- `colorBackgroundBrand`
- `colorBackgroundBrandOnDark`
- `colorBackgroundDark`
- `colorBackgroundInteractiveActiveOnDark`
- `colorBorderInteractivePress`
- `colorCommercialBlue20`
- `colorObjectInformationalEmphasisHighPress`
- `colorObjectInformationalEmphasisLowPressOnDark`
- `colorObjectInteractiveEmphasisHighPress`
- `colorObjectInteractiveEmphasisLowPressOnDark`
- `colorTextInformationalPress`
- `colorTextInteractivePress`
 */
const colorBlue75 = "hsl(200, 98%, 18%)";

/**
`colorBlue80`

Gravity Blue 80

Other aliases:

- `colorBackgroundInteractiveFocusOnDark`
- `colorBackgroundInteractiveHoverOnDark`
- `colorObjectInformationalEmphasisLowHoverOnDark`
- `colorObjectInteractiveEmphasisLowHoverOnDark`
- `colorObjectInteractiveEmphasisNonePressOnDark`
 */
const colorBlue80 = "hsl(199, 88%, 16%)";

/**
`colorBlue90`

Gravity Blue 90
 */
const colorBlue90 = "hsl(201, 45%, 10%)";

/**
`colorBlue95`

Gravity Blue 95 (Darkest)
 */
const colorBlue95 = "hsl(206, 23%, 6%)";

/**
`colorRed05`

Gravity Red 05 (Lightest)

Other aliases:

- `colorAccentRed95`
- `colorBackgroundStatusError`
- `colorObjectCriticalEmphasisLow`
- `colorObjectCriticalEmphasisNoneFocus`
- `colorObjectCriticalEmphasisNoneHover`
 */
const colorRed05 = "hsl(0, 100%, 97%)";

/**
`colorRed10`

Gravity Red 10

Other aliases:

- `colorObjectCriticalEmphasisLowHover`
- `colorObjectCriticalEmphasisNonePress`
 */
const colorRed10 = "hsl(0, 100%, 94%)";

/**
`colorRed15`

Gravity Red 15

Other aliases:

- `colorObjectCriticalEmphasisLowPress`
- `colorTextCriticalPressOnDark`
 */
const colorRed15 = "hsl(359, 100%, 89%)";

/**
`colorRed20`

Gravity Red 20

Other aliases:

- `colorBorderCriticalPressOnDark`
- `colorObjectCriticalEmphasisHighPressOnDark`
 */
const colorRed20 = "hsl(359, 100%, 86%)";

/**
`colorRed25`

Gravity Red 25

Other aliases:

- `colorBorderCriticalHoverOnDark`
- `colorObjectCriticalEmphasisHighHoverOnDark`
- `colorTextCriticalHoverOnDark`
 */
const colorRed25 = "hsl(359, 100%, 80%)";

/**
`colorRed35`

Gravity Red 35

Other aliases:

- `colorBorderCriticalOnDark`
- `colorBorderDotCriticalOnDark`
- `colorObjectCriticalEmphasisHighOnDark`
- `colorObjectDotCriticalOnDark`
- `colorTextCriticalOnDark`
 */
const colorRed35 = "hsl(359, 100%, 71%)";

/**
`colorRed45`

Gravity Red 45

Other aliases:

- `colorObjectDotCritical`
 */
const colorRed45 = "hsl(359, 75%, 59%)";

/**
`colorRed55`

Gravity Red 55

Other aliases:

- `colorAccentRed45`
- `colorBorderCritical`
- `colorBorderError`
- `colorBorderStatusError`
- `colorIconNegative`
- `colorIconStatusError`
- `colorObjectCriticalEmphasisHigh`
- `colorTextCritical`
- `colorTextError`
- `colorTextNegative`
 */
const colorRed55 = "hsl(359, 70%, 47%)";

/**
`colorRed65`

Gravity Red 65

Other aliases:

- `colorAccentRed40`
- `colorBorderCriticalHover`
- `colorBorderDotCritical`
- `colorBorderErrorFocus`
- `colorBorderErrorHover`
- `colorObjectCriticalEmphasisHighHover`
- `colorTextCriticalHover`
- `colorTextErrorFocus`
- `colorTextErrorHover`
 */
const colorRed65 = "hsl(359, 65%, 37%)";

/**
`colorRed75`

Gravity Red 75

Other aliases:

- `colorBorderCriticalPress`
- `colorBorderErrorActive`
- `colorObjectCriticalEmphasisHighPress`
- `colorObjectCriticalEmphasisLowPressOnDark`
- `colorTextCriticalPress`
- `colorTextErrorActive`
 */
const colorRed75 = "hsl(359, 57%, 29%)";

/**
`colorRed80`

Gravity Red 80

Other aliases:

- `colorObjectCriticalEmphasisLowHoverOnDark`
- `colorObjectCriticalEmphasisNonePressOnDark`
 */
const colorRed80 = "hsl(359, 51%, 25%)";

/**
`colorRed85`

Gravity Red 85

Other aliases:

- `colorObjectCriticalEmphasisLowOnDark`
- `colorObjectCriticalEmphasisNoneFocusOnDark`
- `colorObjectCriticalEmphasisNoneHoverOnDark`
 */
const colorRed85 = "hsl(0, 39%, 18%)";

/**
`colorRed90`

Gravity Red 90
 */
const colorRed90 = "hsl(0, 30%, 14%)";

/**
`colorRed95`

Gravity Red 95 (Darkest)
 */
const colorRed95 = "hsl(0, 22%, 8%)";

/**
`colorGreen05`

Gravity Green 05 (Lightest)

Other aliases:

- `colorAccentGreen90`
- `colorBackgroundStatusSuccess`
- `colorObjectFavorableEmphasisLow`
 */
const colorGreen05 = "hsl(108, 80%, 94%)";

/**
`colorGreen10`

Gravity Green 10

Other aliases:

- `colorObjectFavorableEmphasisLowHover`
 */
const colorGreen10 = "hsl(108, 77%, 85%)";

/**
`colorGreen15`

Gravity Green 15

Other aliases:

- `colorObjectFavorableEmphasisLowPress`
 */
const colorGreen15 = "hsl(108, 73%, 74%)";

/**
`colorGreen20`

Gravity Green 20

Other aliases:

- `colorBorderFavorablePressOnDark`
- `colorObjectFavorableEmphasisHighPressOnDark`
- `colorTextFavorablePressOnDark`
 */
const colorGreen20 = "hsl(107, 63%, 63%)";

/**
`colorGreen25`

Gravity Green 25

Other aliases:

- `colorBorderFavorableHoverOnDark`
- `colorObjectFavorableEmphasisHighHoverOnDark`
- `colorTextFavorableHoverOnDark`
 */
const colorGreen25 = "hsl(108, 60%, 55%)";

/**
`colorGreen35`

Gravity Green 35

Other aliases:

- `colorBorderDotFavorableOnDark`
- `colorBorderFavorableOnDark`
- `colorObjectDotFavorableOnDark`
- `colorObjectFavorableEmphasisHighOnDark`
- `colorTextFavorableOnDark`
 */
const colorGreen35 = "hsl(108, 61%, 44%)";

/**
`colorGreen45`

Gravity Green 45

Other aliases:

- `colorObjectDotFavorable`
 */
const colorGreen45 = "hsl(108, 76%, 33%)";

/**
`colorGreen55`

Gravity Green 55

Other aliases:

- `colorAccentGreen25`
- `colorBorderFavorable`
- `colorBorderStatusSuccess`
- `colorIconPositive`
- `colorIconStatusSuccess`
- `colorObjectFavorableEmphasisHigh`
- `colorTextFavorable`
- `colorTextPositive`
 */
const colorGreen55 = "hsl(108, 88%, 26%)";

/**
`colorGreen65`

Gravity Green 65

Other aliases:

- `colorBorderDotFavorable`
- `colorBorderFavorableHover`
- `colorObjectFavorableEmphasisHighHover`
- `colorTextFavorableHover`
 */
const colorGreen65 = "hsl(108, 81%, 21%)";

/**
`colorGreen75`

Gravity Green 75

Other aliases:

- `colorBorderFavorablePress`
- `colorObjectFavorableEmphasisHighPress`
- `colorObjectFavorableEmphasisLowPressOnDark`
- `colorTextFavorablePress`
 */
const colorGreen75 = "hsl(108, 79%, 15%)";

/**
`colorGreen80`

Gravity Green 80

Other aliases:

- `colorObjectFavorableEmphasisLowHoverOnDark`
 */
const colorGreen80 = "hsl(108, 73%, 13%)";

/**
`colorGreen85`

Gravity Green 85

Other aliases:

- `colorObjectFavorableEmphasisLowOnDark`
 */
const colorGreen85 = "hsl(107, 54%, 12%)";

/**
`colorGreen90`

Gravity Green 90
 */
const colorGreen90 = "hsl(112, 26%, 11%)";

/**
`colorGreen95`

Gravity Green 95 (Darkest)
 */
const colorGreen95 = "hsl(108, 33%, 6%)";

/**
`colorYellow05`

Gravity Yellow 05 (Lightest)

Other aliases:

- `colorAccentYellow90`
- `colorBackgroundStatusWarning`
- `colorObjectWarningEmphasisLow`
 */
const colorYellow05 = "hsl(46, 100%, 91%)";

/**
`colorYellow10`

Gravity Yellow 10

Other aliases:

- `colorBorderWarningPressOnDark`
- `colorObjectWarningEmphasisHighPressOnDark`
- `colorObjectWarningEmphasisLowHover`
- `colorTextWarningPressOnDark`
 */
const colorYellow10 = "hsl(46, 100%, 80%)";

/**
`colorYellow15`

Gravity Yellow 15

Other aliases:

- `colorBorderWarningHoverOnDark`
- `colorObjectWarningEmphasisHighHoverOnDark`
- `colorObjectWarningEmphasisLowPress`
- `colorTextWarningHoverOnDark`
 */
const colorYellow15 = "hsl(47, 95%, 67%)";

/**
`colorYellow20`

Gravity Yellow 20

Other aliases:

- `colorBorderDotWarningOnDark`
- `colorBorderWarningOnDark`
- `colorObjectDotWarning`
- `colorObjectDotWarningOnDark`
- `colorObjectWarningEmphasisHigh`
- `colorObjectWarningEmphasisHighOnDark`
- `colorTextWarningOnDark`
 */
const colorYellow20 = "hsl(47, 95%, 50%)";

/**
`colorYellow25`

Gravity Yellow 25

Other aliases:

- `colorAccentYellow50`
- `colorBorderStatusWarning`
- `colorIconStatusWarning`
- `colorObjectWarningEmphasisHighHover`
 */
const colorYellow25 = "hsl(44, 86%, 52%)";

/**
`colorYellow35`

Gravity Yellow 35

Other aliases:

- `colorObjectWarningEmphasisHighPress`
 */
const colorYellow35 = "hsl(44, 96%, 41%)";

/**
`colorYellow45`

Gravity Yellow 45

Other aliases:

- `colorBorderDotWarning`
 */
const colorYellow45 = "hsl(44, 99%, 33%)";

/**
`colorYellow55`

Gravity Yellow 55

Other aliases:

- `colorBorderWarning`
- `colorTextWarning`
 */
const colorYellow55 = "hsl(42, 100%, 28%)";

/**
`colorYellow65`

Gravity Yellow 65

Other aliases:

- `colorBorderWarningHover`
- `colorTextWarningHover`
 */
const colorYellow65 = "hsl(43, 100%, 21%)";

/**
`colorYellow75`

Gravity Yellow 75

Other aliases:

- `colorBorderWarningPress`
- `colorTextWarningPress`
 */
const colorYellow75 = "hsl(44, 100%, 15%)";

/**
`colorYellow80`

Gravity Yellow 80

Other aliases:

- `colorObjectWarningEmphasisLowHoverOnDark`
 */
const colorYellow80 = "hsl(44, 100%, 13%)";

/**
`colorYellow85`

Gravity Yellow 85

Other aliases:

- `colorObjectWarningEmphasisLowOnDark`
- `colorObjectWarningEmphasisLowPressOnDark`
 */
const colorYellow85 = "hsl(44, 100%, 10%)";

/**
`colorYellow90`

Gravity Yellow 90
 */
const colorYellow90 = "hsl(44, 100%, 8%)";

/**
`colorYellow95`

Gravity Yellow 95 (Darkest)
 */
const colorYellow95 = "hsl(43, 69%, 5%)";

/**
`colorPurple35`

Gravity Purple 35. Use for visited links only.

Other aliases:

- `colorTextVisitedOnDark`
 */
const colorPurple35 = "hsl(270, 75%, 73%)";

/**
`colorPurple55`

Gravity Purple 55. Use for visited links only.

Other aliases:

- `colorTextVisited`
 */
const colorPurple55 = "hsl(270, 61%, 54%)";

/**
`colorInk10`

Alias of `colorGray95`
@deprecated 4.3.0 Use `import { colorGray95 } from "@cof/omni-tokens"`
 */
const colorInk10 = "hsl(0, 0%, 7%)";

/**
`colorInk30`

Alias of `colorGray65`
@deprecated 4.3.0 Use `import { colorGray65 } from "@cof/omni-tokens"`
 */
const colorInk30 = "hsl(0, 0%, 32%)";

/**
`colorInk40`

Alias of `colorGray55`
Other aliases:

- `colorTextReadonly`
@deprecated 4.3.0 Use `import { colorGray55 } from "@cof/omni-tokens"`
 */
const colorInk40 = "hsl(0, 0%, 43%)";

/**
`colorInk60`

Alias of `colorGray35`
@deprecated 4.3.0 Use `import { colorGray35 } from "@cof/omni-tokens"`
 */
const colorInk60 = "hsl(0, 0%, 62%)";

/**
`colorInk80`

Alias of `colorGray15`
Other aliases:

- `colorBorderReadonly`
@deprecated 4.3.0 Use `import { colorGray15 } from "@cof/omni-tokens"`
 */
const colorInk80 = "hsl(0, 0%, 83%)";

/**
`colorInk90`

Alias of `colorGray10`
@deprecated 4.3.0 Use `import { colorGray10 } from "@cof/omni-tokens"`
 */
const colorInk90 = "hsl(0, 0%, 91%)";

/**
`colorInk95`

Alias of `colorGray05`
Other aliases:

- `colorBackgroundReadonly`
@deprecated 4.3.0 Use `import { colorGray05 } from "@cof/omni-tokens"`
 */
const colorInk95 = "hsl(0, 0%, 96%)";

/**
`colorCommercialBlue20`

Alias of `colorBlue75`
@deprecated 4.3.0 Use `import { colorBlue75 } from "@cof/omni-tokens"`
 */
const colorCommercialBlue20 = "hsl(200, 98%, 18%)";

/**
`colorAccentBlue25`

Alias of `colorBlue65`
@deprecated 4.3.0 Use `import { colorBlue65 } from "@cof/omni-tokens"`
 */
const colorAccentBlue25 = "hsl(200, 98%, 26%)";

/**
`colorAccentBlue30`

Alias of `colorBlue55`
@deprecated 4.3.0 Use `import { colorBlue55 } from "@cof/omni-tokens"`
 */
const colorAccentBlue30 = "hsl(200, 100%, 33%)";

/**
`colorAccentBlue35`

Alias of `colorBlue45`
@deprecated 4.3.0 Use `import { colorBlue45 } from "@cof/omni-tokens"`
 */
const colorAccentBlue35 = "hsl(200, 82%, 42%)";

/**
`colorAccentBlue60`

Alias of `colorBlue25`
@deprecated 4.3.0 Use `import { colorBlue25 } from "@cof/omni-tokens"`
 */
const colorAccentBlue60 = "hsl(200, 97%, 66%)";

/**
`colorAccentBlue95`

Alias of `colorBlue05`
@deprecated 4.3.0 Use `import { colorBlue05 } from "@cof/omni-tokens"`
 */
const colorAccentBlue95 = "hsl(201, 100%, 96%)";

/**
`colorAccentGreen25`

Alias of `colorGreen55`
@deprecated 4.3.0 Use `import { colorGreen55 } from "@cof/omni-tokens"`
 */
const colorAccentGreen25 = "hsl(108, 88%, 26%)";

/**
`colorAccentGreen90`

Alias of `colorGreen05`
@deprecated 4.3.0 Use `import { colorGreen05 } from "@cof/omni-tokens"`
 */
const colorAccentGreen90 = "hsl(108, 80%, 94%)";

/**
`colorAccentYellow50`

Alias of `colorYellow25`
@deprecated 4.3.0 Use `import { colorYellow25 } from "@cof/omni-tokens"`
 */
const colorAccentYellow50 = "hsl(44, 86%, 52%)";

/**
`colorAccentYellow90`

Alias of `colorYellow05`
@deprecated 4.3.0 Use `import { colorYellow05 } from "@cof/omni-tokens"`
 */
const colorAccentYellow90 = "hsl(46, 100%, 91%)";

/**
`colorAccentOrange50`

OMNI Accent Orange 50. Use for rating scale only.
 */
const colorAccentOrange50 = "hsl(35, 86%, 49%)";

/**
`colorAccentRed40`

Alias of `colorRed65`
@deprecated 4.3.0 Use `import { colorRed65 } from "@cof/omni-tokens"`
 */
const colorAccentRed40 = "hsl(359, 65%, 37%)";

/**
`colorAccentRed45`

Alias of `colorRed55`
@deprecated 4.3.0 Use `import { colorRed55 } from "@cof/omni-tokens"`
 */
const colorAccentRed45 = "hsl(359, 70%, 47%)";

/**
`colorAccentRed95`

Alias of `colorRed05`
@deprecated 4.3.0 Use `import { colorRed05 } from "@cof/omni-tokens"`
 */
const colorAccentRed95 = "hsl(0, 100%, 97%)";

/**
`opacity0`
 */
const opacity0 = "0";

/**
`opacity5`
 */
const opacity5 = "0.05";

/**
`opacity95`
 */
const opacity95 = "0.95";

/**
`opacity100`
 */
const opacity100 = "1";

/**
`mediaQueryTiny599AndDown`

Tiny screens only
 */
const mediaQueryTiny599AndDown = "(max-width: 599px)";

/**
`mediaQuerySmall600AndUp`

Small screens and up
 */
const mediaQuerySmall600AndUp = "(min-width: 600px)";

/**
`mediaQuerySmall600To899`

Small screens only
 */
const mediaQuerySmall600To899 = "(min-width: 600px) and (max-width: 899px)";

/**
`mediaQueryMedium900AndUp`

Medium screens and up
 */
const mediaQueryMedium900AndUp = "(min-width: 900px)";

/**
`mediaQueryMedium900To1199`

Medium screens only
 */
const mediaQueryMedium900To1199 = "(min-width: 900px) and (max-width: 1199px)";

/**
`mediaQueryLarge1200AndUp`

Large screens and up
 */
const mediaQueryLarge1200AndUp = "(min-width: 1200px)";

/**
`mediaQueryLarge1200To1799`

Large screens only
 */
const mediaQueryLarge1200To1799 = "(min-width: 1200px) and (max-width: 1799px)";

/**
`mediaQueryHuge1800AndUp`

Huge screens and up
 */
const mediaQueryHuge1800AndUp = "(min-width: 1800px)";

/**
`spacingZero`
 */
const spacingZero = 0;

/**
`spacingTiny`
 */
const spacingTiny = "0.25rem";

/**
`spacingSmall`
 */
const spacingSmall = "0.5rem";

/**
`spacingMedium`
 */
const spacingMedium = "1rem";

/**
`spacingLarge`
 */
const spacingLarge = "1.5rem";

/**
`spacingHuge`
 */
const spacingHuge = "2rem";

/**
`spacingGiant`
 */
const spacingGiant = "4rem";

/**
`negativeMarginTiny`
 */
const negativeMarginTiny = "-0.25rem";

/**
`negativeMarginSmall`
 */
const negativeMarginSmall = "-0.5rem";

/**
`negativeMarginMedium`
 */
const negativeMarginMedium = "-1rem";

/**
`negativeMarginLarge`
 */
const negativeMarginLarge = "-1.5rem";

/**
`negativeMarginHuge`
 */
const negativeMarginHuge = "-2rem";

/**
`negativeMarginGiant`
 */
const negativeMarginGiant = "-4rem";

/**
`widthFull`
 */
const widthFull = "100%";

/**
`widthHalf`
 */
const widthHalf = "50%";

/**
`widthQuarter`
 */
const widthQuarter = "25%";

/**
`heightFull`
 */
const heightFull = "100%";

/**
`zIndex0`
 */
const zIndex0 = 0;

/**
`zIndex100`
 */
const zIndex100 = 100;

/**
`zIndex200`
 */
const zIndex200 = 200;

/**
`zIndex300`
 */
const zIndex300 = 300;

/**
`fontFaceOptimistBold`
 */
const fontFaceOptimistBold = {
  "@font-face": {
    fontFamily: "Optimist",
    fontWeight: 700,
    src: 'url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_Bd.woff2") format("woff2"), url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_Bd.woff") format("woff"), url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_Bd.ttf") format("truetype")'
  }
};

/**
`fontFaceOptimistBoldItalic`
 */
const fontFaceOptimistBoldItalic = {
  "@font-face": {
    fontFamily: "Optimist",
    fontStyle: "italic",
    fontWeight: 700,
    src: 'url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_BdIt.woff2") format("woff2"), url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_BdIt.woff") format("woff"), url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_BdIt.ttf") format("truetype")'
  }
};

/**
`fontFaceOptimistSemiBold`
 */
const fontFaceOptimistSemiBold = {
  "@font-face": {
    fontFamily: "Optimist",
    fontWeight: 600,
    src: 'url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_SBd.woff2") format("woff2"), url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_SBd.woff") format("woff"), url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_SBd.ttf") format("truetype")'
  }
};

/**
`fontFaceOptimistSemiBoldItalic`
 */
const fontFaceOptimistSemiBoldItalic = {
  "@font-face": {
    fontFamily: "Optimist",
    fontStyle: "italic",
    fontWeight: 600,
    src: 'url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_SBdIt.woff2") format("woff2"), url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_SBdIt.woff") format("woff"), url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_SBdIt.ttf") format("truetype")'
  }
};

/**
`fontFaceOptimistRegular`
 */
const fontFaceOptimistRegular = {
  "@font-face": {
    fontFamily: "Optimist",
    fontWeight: 400,
    src: 'url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_Rg.woff2") format("woff2"), url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_Rg.woff") format("woff"), url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_Rg.ttf") format("truetype")'
  }
};

/**
`fontFaceOptimistRegularItalic`
 */
const fontFaceOptimistRegularItalic = {
  "@font-face": {
    fontFamily: "Optimist",
    fontStyle: "italic",
    fontWeight: 400,
    src: 'url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_It.woff2") format("woff2"), url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_It.woff") format("woff"), url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_It.ttf") format("truetype")'
  }
};

/**
`fontFaceOptimistLight`
 */
const fontFaceOptimistLight = {
  "@font-face": {
    fontFamily: "Optimist",
    fontWeight: 300,
    src: 'url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_Lt.woff2") format("woff2"), url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_Lt.woff") format("woff"), url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_Lt.ttf") format("truetype")'
  }
};

/**
`fontFaceOptimistLightItalic`
 */
const fontFaceOptimistLightItalic = {
  "@font-face": {
    fontFamily: "Optimist",
    fontStyle: "italic",
    fontWeight: 300,
    src: 'url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_LtIt.woff2") format("woff2"), url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_LtIt.woff") format("woff"), url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_LtIt.ttf") format("truetype")'
  }
};

/**
`fontFaceOptimistExtraLight`
 */
const fontFaceOptimistExtraLight = {
  "@font-face": {
    fontFamily: "Optimist",
    fontWeight: 200,
    src: 'url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_XLt.woff2") format("woff2"), url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_XLt.woff") format("woff"), url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_XLt.ttf") format("truetype")'
  }
};

/**
`fontFaceOptimistExtraLightItalic`
 */
const fontFaceOptimistExtraLightItalic = {
  "@font-face": {
    fontFamily: "Optimist",
    fontStyle: "italic",
    fontWeight: 200,
    src: 'url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_XLtIt.woff2") format("woff2"), url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_XLtIt.woff") format("woff"), url("https://www.capitalone.com/assets/enterprise/fonts/Optimist_W_XLtIt.ttf") format("truetype")'
  }
};

/**
`fontFamilyOptimist`
 */
const fontFamilyOptimist = '"Optimist", system-ui, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"';

/**
`fontFamilySystem`
 */
const fontFamilySystem = 'system-ui, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"';

/**
`fontFamilyCode`
 */
const fontFamilyCode = "SFMono-Regular, Fira Code, Consolas, Liberation Mono, Menlo, Monaco, Consolas, monospace";

/**
`fontFamilyLegacy`
 */
const fontFamilyLegacy = '"Helvetica", "Helvetica Neue", "Arial"';

/**
`fontSizeBodyTiny`

Use for metadata, markers, charts.
 */
const fontSizeBodyTiny = "0.75rem";

/**
`fontSizeBodySmall`

Use for labels, legal text.
 */
const fontSizeBodySmall = "0.875rem";

/**
`fontSizeBodyMedium`

Use for body text.
 */
const fontSizeBodyMedium = "1rem";

/**
`fontSizeBodyLarge`
 */
const fontSizeBodyLarge = "1.25rem";

/**
`fontSizeBodyHuge`
 */
const fontSizeBodyHuge = "1.5rem";

/**
`fontSizeHeadingTiny`
 */
const fontSizeHeadingTiny = "1rem";

/**
`fontSizeHeadingSmall`
 */
const fontSizeHeadingSmall = "1.25rem";

/**
`fontSizeHeadingMedium`
 */
const fontSizeHeadingMedium = "1.5rem";

/**
`fontSizeHeadingLarge`
 */
const fontSizeHeadingLarge = "2rem";

/**
`fontSizeHeadingHuge`
 */
const fontSizeHeadingHuge = "3rem";

/**
`fontSizeMetricLarge`
 */
const fontSizeMetricLarge = "2rem";

/**
`fontSizeMetricHuge`
 */
const fontSizeMetricHuge = "2.5rem";

/**
`fontSizeTitleMedium`
 */
const fontSizeTitleMedium = "2rem";

/**
`fontSizeTitleLarge`
 */
const fontSizeTitleLarge = "2.5rem";

/**
`fontSizeTitleHuge`
 */
const fontSizeTitleHuge = "3rem";

/**
`fontSizeTitleGiant`
 */
const fontSizeTitleGiant = "4rem";

/**
`fontWeight200ExtraLight`
 */
const fontWeight200ExtraLight = 200;

/**
`fontWeight300Light`
 */
const fontWeight300Light = 300;

/**
`fontWeight400Regular`
 */
const fontWeight400Regular = 400;

/**
`fontWeight600SemiBold`
 */
const fontWeight600SemiBold = 600;

/**
`fontWeight700Bold`

Using Bold is discouraged within the Gravity visual language. Use Semibold.
 */
const fontWeight700Bold = 700;

/**
`letterSpacingDefault`
 */
const letterSpacingDefault = "normal";

/**
`letterSpacingEyebrowPrimary`

Use for eyebrow text, often used as categorization labels
 */
const letterSpacingEyebrowPrimary = "0.5px";

/**
`letterSpacingEyebrowSecondary`

Use for eyebrow text, often used as categorization labels
 */
const letterSpacingEyebrowSecondary = "1.5px";

/**
`lineHeight075`
 */
const lineHeight075 = 0.75;

/**
`lineHeight0875`
 */
const lineHeight0875 = 0.875;

/**
`lineHeight1`
 */
const lineHeight1 = 1;

/**
`lineHeight125`
 */
const lineHeight125 = 1.25;

/**
`lineHeight133`
 */
const lineHeight133 = 1.33;

/**
`lineHeight1375`
 */
const lineHeight1375 = 1.375;

/**
`lineHeight150`
 */
const lineHeight150 = 1.5;

/**
`lineHeight1625`
 */
const lineHeight1625 = 1.625;

/**
`lineHeight175`
 */
const lineHeight175 = 1.75;

/**
`lineHeight2`
 */
const lineHeight2 = 2;

/**
`lineHeightButton`

Use as line-height for button elements
 */
const lineHeightButton = "20px";

/**
`lineHeightInput`

Use as line-height for input controls
 */
const lineHeightInput = "20px";

/**
`lineHeightTableCell`

Use as line-height for table cells.
 */
const lineHeightTableCell = "20px";

/**
`lineHeightBodyTiny`
 */
const lineHeightBodyTiny = 1.3333;

/**
`lineHeightBodySmall`
 */
const lineHeightBodySmall = 1.2857;

/**
`lineHeightBodyMedium`
 */
const lineHeightBodyMedium = 1.375;

/**
`lineHeightBodyLarge`
 */
const lineHeightBodyLarge = 1.3;

/**
`lineHeightBodyHuge`
 */
const lineHeightBodyHuge = 1.3333;

/**
`lineHeightTitleMedium`
 */
const lineHeightTitleMedium = "2.625rem";

/**
`lineHeightTitleLarge`
 */
const lineHeightTitleLarge = "3.25rem";

/**
`lineHeightTitleHuge`
 */
const lineHeightTitleHuge = "3.875rem";

/**
`lineHeightTitleGiant`
 */
const lineHeightTitleGiant = "4.75rem";

/**
`lineHeightHeadingTiny`
 */
const lineHeightHeadingTiny = 1.375;

/**
`lineHeightHeadingSmall`
 */
const lineHeightHeadingSmall = 1.3;

/**
`lineHeightHeadingMedium`
 */
const lineHeightHeadingMedium = 1.3333;

/**
`lineHeightHeadingLarge`
 */
const lineHeightHeadingLarge = 1.3125;

/**
`lineHeightHeadingHuge`
 */
const lineHeightHeadingHuge = 1.3333;

/**
`lineHeightMetricLarge`
 */
const lineHeightMetricLarge = 1;

/**
`lineHeightMetricHuge`
 */
const lineHeightMetricHuge = 1;

/**
`lineLengthTiny`
 */
const lineLengthTiny = "30rem";

/**
`lineLengthSmall`
 */
const lineLengthSmall = "40rem";

/**
`lineLengthMedium`
 */
const lineLengthMedium = "50rem";

/**
`lineLengthLarge`
 */
const lineLengthLarge = "60rem";

/**
`lineLengthHuge`
 */
const lineLengthHuge = "70rem";

/**
`outlineInteractive`
 */
const outlineInteractive = "1px solid";

/**
`outlineDisabled`
 */
const outlineDisabled = "1px dotted";

/**
`border1pxSolid`

Use as primary border width & style
 */
const border1pxSolid = "1px solid";

/**
`border1pxDotted`

Use as secondary border width & style
 */
const border1pxDotted = "1px dotted";

/**
`border2pxSolid`
 */
const border2pxSolid = "2px solid";

/**
`border4pxSolid`
 */
const border4pxSolid = "4px solid";

/**
`borderRadiusGiant`
 */
const borderRadiusGiant = "12px";

/**
`borderRadiusLarge`
 */
const borderRadiusLarge = "8px";

/**
`borderRadiusMedium`
 */
const borderRadiusMedium = "6px";

/**
`borderRadiusSmall`
 */
const borderRadiusSmall = "4px";

/**
`borderRadiusTiny`
 */
const borderRadiusTiny = "2px";

/**
`borderRadiusZero`
 */
const borderRadiusZero = "0px";

/**
`borderRadiusPill`
 */
const borderRadiusPill = "9999px";

/**
`borderRadiusCircle`
 */
const borderRadiusCircle = "50%";

/**
`borderRadiusNone`


@deprecated 5.0.0 Use `import { borderRadiusZero } from "@cof/omni-tokens"`
 */
const borderRadiusNone = "none";

/**
`borderRadiusFull`


@deprecated 5.0.0 Use `import { borderRadiusPill } from "@cof/omni-tokens"`
 */
const borderRadiusFull = "9999px";

/**
`boxShadowTiny`

Uses `colorShadow`
 */
const boxShadowTiny = "0px 0px 0.5px hsla(0, 0%, 7.1%, 0.09), 0px 1px 1px hsla(0, 0%, 7.1%, 0.09), 0px 0px 2px hsla(0, 0%, 7.1%, 0.09)";

/**
`boxShadowSmall`

Uses `colorShadow`
 */
const boxShadowSmall = "0px 1px 2px hsla(0, 0%, 7.1%, 0.09), 0px 1px 2.75px hsla(0, 0%, 7.1%, 0.09), 0px 1px 4px hsla(0, 0%, 7.1%, 0.09)";

/**
`boxShadowMedium`

Uses `colorShadow`
 */
const boxShadowMedium = "0px 1px 1px hsla(0, 0%, 7.1%, 0.09), 0px 1px 4px hsla(0, 0%, 7.1%, 0.09), 0px 4px 6px hsla(0, 0%, 7.1%, 0.09)";

/**
`boxShadowTopMedium`

Use on the top edge of a component

Other aliases:

- `boxShadowStickyFooter`
 */
const boxShadowTopMedium = "0px -4px 2px -2px hsla(0, 0%, 7.1%, 0.09),0px -6px 6px -4px hsla(0, 0%, 7.1%, 0.09),0px -10px 12px -10px hsla(0, 0%, 7.1%, 0.09)";

/**
`boxShadowBottomMedium`

Use at the bottom edge of a component

Other aliases:

- `boxShadowStickyHeader`
 */
const boxShadowBottomMedium = "0px 4px 2px -2px hsla(0, 0%, 7.1%, 0.09),0px 6px 6px -4px hsla(0, 0%, 7.1%, 0.09),0px 10px 12px -10px hsla(0, 0%, 7.1%, 0.09)";

/**
`boxShadowLeftTiny`

Use at the left edge of a component
 */
const boxShadowLeftTiny = "-2.5px 0px 2px -0.75px hsla(0, 0%, 7.1%, 0.09), -2px 0px 2px -0.75px  hsla(0, 0%, 7.1%, 0.09), -1.5px 0px 2px -0.75px hsla(0, 0%, 7.1%, 0.09)";

/**
`boxShadowRightTiny`

Use at the right edge of a component
 */
const boxShadowRightTiny = "2.5px 0px 2px -0.75px hsla(0, 0%, 7.1%, 0.09), 2px 0px 2px -0.75px  hsla(0, 0%, 7.1%, 0.09), 1.5px 0px 2px -0.75px hsla(0, 0%, 7.1%, 0.09)";

/**
`boxShadowTinyOnDark`

Uses `colorShadowOnDark`
 */
const boxShadowTinyOnDark = "0px 0px 0.5px hsla(200, 97.8%, 18%, 0.39), 0px 1px 1px hsla(200, 97.8%, 18%, 0.39), 0px 0px 2px hsla(200, 97.8%, 18%, 0.39)";

/**
`boxShadowSmallOnDark`

Uses `colorShadowOnDark`
 */
const boxShadowSmallOnDark = "0px 1px 2px hsla(200, 97.8%, 18%, 0.39), 0px 1px 2.75px hsla(200, 97.8%, 18%, 0.39), 0px 1px 4px hsla(200, 97.8%, 18%, 0.39)";

/**
`boxShadowMediumOnDark`

Uses `colorShadowOnDark`
 */
const boxShadowMediumOnDark = "0px 1px 1px hsla(200, 97.8%, 18%, 0.39), 0px 1px 4px hsla(200, 97.8%, 18%, 0.39), 0px 4px 6px hsla(200, 97.8%, 18%, 0.39)";

/**
`boxShadowTopMediumOnDark`

Use on the top edge of a component
 */
const boxShadowTopMediumOnDark = "0px -4px 2px -2px hsla(200, 97.8%, 18%, 0.39),0px -6px 6px -4px hsla(200, 97.8%, 18%, 0.39),0px -10px 12px -10px hsla(200, 97.8%, 18%, 0.39)";

/**
`boxShadowBottomMediumOnDark`

Use at the bottom edge of a component
 */
const boxShadowBottomMediumOnDark = "0px 4px 2px -2px hsla(200, 97.8%, 18%, 0.39),0px 6px 6px -4px hsla(200, 97.8%, 18%, 0.39),0px 10px 12px -10px hsla(200, 97.8%, 18%, 0.39)";

/**
`easingStandardPurposeful`

This is the standard default easing curve to use for most general motion.
 */
const easingStandardPurposeful = "cubic-bezier(0.30, 0.00, 0.00, 1.00)";

/**
`easingStandardExpressive`

This is the standard default easing curve to use for most general motion.
 */
const easingStandardExpressive = "cubic-bezier(0.94, 0.03, 0.03, 1.13)";

/**
`easingEntrancePurposeful`

This curve is great for objects entering into focus, they come in quickly but ease to a stop, drawing attention to them.
 */
const easingEntrancePurposeful = "cubic-bezier(0.17, 0.17, 0.20, 1.00)";

/**
`easingEntranceExpressive`

This curve is great for objects entering into focus, they come in quickly but ease to a stop, drawing attention to them.
 */
const easingEntranceExpressive = "cubic-bezier(0.14, 0.68, 0.19, 1.11)";

/**
`easingExitPurposeful`

This curve is great for objects exiting from focus, they acceclerate quickly out of view or back to a default value, drawing minimal attention as they go.
 */
const easingExitPurposeful = "cubic-bezier(1.00, 0.01, 0.65, 0.70)";

/**
`easingExitExpressive`

This curve is great for objects exiting from focus, they acceclerate quickly out of view or back to a default value, drawing minimal attention as they go.
 */
const easingExitExpressive = "cubic-bezier(1.00, -0.28, 0.81, 0.76)";

/**
`boxShadowStickyHeader`

Use as the box-shadow for sticky header components

Alias of `boxShadowBottomMedium`
 */
const boxShadowStickyHeader = "0px 4px 2px -2px hsla(0, 0%, 7.1%, 0.09),0px 6px 6px -4px hsla(0, 0%, 7.1%, 0.09),0px 10px 12px -10px hsla(0, 0%, 7.1%, 0.09)";

/**
`boxShadowStickyFooter`

Use as the box-shadow for sticky footer components

Alias of `boxShadowTopMedium`
 */
const boxShadowStickyFooter = "0px -4px 2px -2px hsla(0, 0%, 7.1%, 0.09),0px -6px 6px -4px hsla(0, 0%, 7.1%, 0.09),0px -10px 12px -10px hsla(0, 0%, 7.1%, 0.09)";

/**
`colorBackgroundTransparent`

Use for background-color on transparent components
 */
const colorBackgroundTransparent = "hsla(0, 0%, 0%, 0)";

/**
`colorBackgroundWhite`

Use for background-color on primary, content-oriented components

Alias of `colorWhite`
@deprecated 4.3.0 Use `import { colorBackgroundBase1 } from "@cof/omni-gravity-tokens"`
 */
const colorBackgroundWhite = "hsl(0, 0%, 100%)";

/**
`colorBackgroundLight`

Use for background-color on secondary components

Alias of `colorGray05`
@deprecated 4.3.0 Use `import { colorBackgroundBase0 } from "@cof/omni-gravity-tokens"`
 */
const colorBackgroundLight = "hsl(0, 0%, 96%)";

/**
`colorBackgroundHighlighted`

Use for background-color on highlighted controls, table rows

Alias of `colorBlue05`
 */
const colorBackgroundHighlighted = "hsl(201, 100%, 96%)";

/**
`colorBackgroundDark`

Alias of `colorBlue75`
@deprecated 4.3.0 Use `import { colorBackgroundBrand } from "@cof/omni-gravity-tokens"` or `import { colorBackgroundBase0OnDark } from "@cof/omni-gravity-tokens"`
 */
const colorBackgroundDark = "hsl(200, 98%, 18%)";

/**
`colorBorderPrimary`

Use for border-color on containers, tables

Alias of `colorGray15`
@deprecated 4.3.0 Use `import { colorBorderPrimary } from "@cof/omni-gravity-tokens"` or `import { colorBorderSubtle } from "@cof/omni-gravity-tokens"`
 */
const colorBorderPrimary = "hsl(0, 0%, 83%)";

/**
`colorBorderPrimaryOnDark`

Use for border-color on dark background

Alias of `colorGray35`
@deprecated 4.3.0 Use `import { colorBorderPrimaryOnDark } from "@cof/omni-gravity-tokens"` or `import { colorBorderSubtleOnDark } from "@cof/omni-gravity-tokens"`
 */
const colorBorderPrimaryOnDark = "hsl(0, 0%, 62%)";

/**
`colorBorderSecondary`

Use for secondary border-color on light backgrounds

Alias of `colorGray10`
@deprecated 4.3.0 Use `import { colorBorderSubtle } from "@cof/omni-gravity-tokens"`
 */
const colorBorderSecondary = "hsl(0, 0%, 91%)";

/**
`colorBorderSecondaryOnDark`

Use for secondary border-color on dark backgrounds

Alias of `colorGray80`
@deprecated 4.3.0 Use `import { colorBorderSubtleOnDark } from "@cof/omni-gravity-tokens"`
 */
const colorBorderSecondaryOnDark = "hsl(0, 0%, 21%)";

/**
`colorBackgroundDisabled`

Use for background-color on disabled components

Alias of `colorGray10`
 */
const colorBackgroundDisabled = "hsl(0, 0%, 91%)";

/**
`colorBorderDisabled`

Use for border-color on disabled components

Alias of `colorGray15`
 */
const colorBorderDisabled = "hsl(0, 0%, 83%)";

/**
`colorBorderDisabledOnDark`

Use for border-color on disabled components on dark background

Alias of `colorGray55`
 */
const colorBorderDisabledOnDark = "hsl(0, 0%, 43%)";

/**
`colorTextDisabled`

Use for text color on disabled components

Alias of `colorGray20`
 */
const colorTextDisabled = "hsl(0, 0%, 75%)";

/**
`colorTextDisabledOnDark`

Use for text color on disabled components on dark background

Alias of `colorGray75`
 */
const colorTextDisabledOnDark = "hsl(0, 0%, 24%)";

/**
`colorBorderError`

Use for border-color on controls with errors

Alias of `colorRed55`
 */
const colorBorderError = "hsl(359, 70%, 47%)";

/**
`colorBorderErrorHover`

Use for border-color on hover state of controls with errors

Alias of `colorRed65`
 */
const colorBorderErrorHover = "hsl(359, 65%, 37%)";

/**
`colorBorderErrorFocus`

Use for border-color on focus state of controls with errors

Alias of `colorRed65`
 */
const colorBorderErrorFocus = "hsl(359, 65%, 37%)";

/**
`colorBorderErrorActive`

Use for border-color on active state of controls with errors

Alias of `colorRed75`
 */
const colorBorderErrorActive = "hsl(359, 57%, 29%)";

/**
`colorTextError`

Use for text color on controls with errors

Alias of `colorRed55`
 */
const colorTextError = "hsl(359, 70%, 47%)";

/**
`colorTextErrorHover`

Use for text color on hover state of controls with errors

Alias of `colorRed65`
 */
const colorTextErrorHover = "hsl(359, 65%, 37%)";

/**
`colorTextErrorFocus`

Use for text color on focus state of controls with errors

Alias of `colorRed65`
 */
const colorTextErrorFocus = "hsl(359, 65%, 37%)";

/**
`colorTextErrorActive`

Use for text color on active state of controls with errors

Alias of `colorRed75`
 */
const colorTextErrorActive = "hsl(359, 57%, 29%)";

/**
`colorIconPrimary`

Use for icon in primary content on white or light backgrounds

Alias of `colorGray95`
 */
const colorIconPrimary = "hsl(0, 0%, 7%)";

/**
`colorIconSecondary`

Use for icon in secondary content on white or light backgrounds

Alias of `colorGray55`
 */
const colorIconSecondary = "hsl(0, 0%, 43%)";

/**
`colorIconPrimaryOnDark`

Use for icon in primary content on dark background

Alias of `colorWhite`
 */
const colorIconPrimaryOnDark = "hsl(0, 0%, 100%)";

/**
`colorIconSecondaryOnDark`

Use for icon in secondary content on dark background

Alias of `colorGray15`
 */
const colorIconSecondaryOnDark = "hsl(0, 0%, 83%)";

/**
`colorIconPositive`

Use for icon indicating positive trends

Alias of `colorGreen55`
 */
const colorIconPositive = "hsl(108, 88%, 26%)";

/**
`colorIconNegative`

Use for icon indicating negative trends

Alias of `colorRed55`
 */
const colorIconNegative = "hsl(359, 70%, 47%)";

/**
`colorIconStatusInformational`

Use as fill color for icon indicating success

Alias of `colorBlue45`
 */
const colorIconStatusInformational = "hsl(200, 82%, 42%)";

/**
`colorIconStatusSuccess`

Use as fill color for icon indicating success

Alias of `colorGreen55`
 */
const colorIconStatusSuccess = "hsl(108, 88%, 26%)";

/**
`colorIconStatusWarning`

Use as fill color for icon indicating warning

Alias of `colorYellow25`
 */
const colorIconStatusWarning = "hsl(44, 86%, 52%)";

/**
`colorIconStatusError`

Use as fill color for icon indicating error

Alias of `colorRed55`
 */
const colorIconStatusError = "hsl(359, 70%, 47%)";

/**
`colorIconSelectArrowPrimary`

Use as primary color for select arrow icon

Alias of `colorGray65`
 */
const colorIconSelectArrowPrimary = "hsl(0, 0%, 32%)";

/**
`colorBackgroundInput`

Use for background-color on input controls

Alias of `colorWhite`
 */
const colorBackgroundInput = "hsl(0, 0%, 100%)";

/**
`colorBorderInput`

Use for border-color on input controls

Alias of `colorGray35`
 */
const colorBorderInput = "hsl(0, 0%, 62%)";

/**
`colorBorderInputChecked`

Use for border-color on checked state of input controls

Alias of `colorBlue45`
 */
const colorBorderInputChecked = "hsl(200, 82%, 42%)";

/**
`colorBorderInputHover`

Use for border-color on hover state of input controls

Alias of `colorBlue45`
 */
const colorBorderInputHover = "hsl(200, 82%, 42%)";

/**
`colorBorderInputFocus`

Use for border-color on focus state of input controls

Alias of `colorBlue45`
 */
const colorBorderInputFocus = "hsl(200, 82%, 42%)";

/**
`colorBorderInputActive`

Use for border-color on active state of input controls

Alias of `colorBlue65`
 */
const colorBorderInputActive = "hsl(200, 98%, 26%)";

/**
`colorTextInput`

Use for text color on input controls

Alias of `colorGray95`
 */
const colorTextInput = "hsl(0, 0%, 7%)";

/**
`colorTextInputIcons`

Use for text color on input icons - search, clear, etc

Alias of `colorGray55`
 */
const colorTextInputIcons = "hsl(0, 0%, 43%)";

/**
`colorTextInputPlaceholder`

Use for text color on input placeholder

Alias of `colorGray55`
 */
const colorTextInputPlaceholder = "hsl(0, 0%, 43%)";

/**
`colorBackgroundInteractiveHover`

Use for background-color on hover state of interactive controls

Alias of `colorBlue05`
 */
const colorBackgroundInteractiveHover = "hsl(201, 100%, 96%)";

/**
`colorBackgroundInteractiveFocus`

Use for background-color on focus state of interactive controls

Alias of `colorBlue05`
 */
const colorBackgroundInteractiveFocus = "hsl(201, 100%, 96%)";

/**
`colorBackgroundInteractiveActive`

Use for background-color on active state of interactive controls

Alias of `colorBlue10`
 */
const colorBackgroundInteractiveActive = "hsl(200, 100%, 90%)";

/**
`colorBackgroundInteractiveHoverOnDark`

Use for background-color on hover state of interactive controls in dark theme

Alias of `colorBlue80`
 */
const colorBackgroundInteractiveHoverOnDark = "hsl(199, 88%, 16%)";

/**
`colorBackgroundInteractiveFocusOnDark`

Use for background-color on focus state of interactive controls in dark theme

Alias of `colorBlue80`
 */
const colorBackgroundInteractiveFocusOnDark = "hsl(199, 88%, 16%)";

/**
`colorBackgroundInteractiveActiveOnDark`

Use for background-color on active state of interactive controls in dark theme

Alias of `colorBlue75`
 */
const colorBackgroundInteractiveActiveOnDark = "hsl(200, 98%, 18%)";

/**
`colorBorderInteractive`

Use for border-color on interactive controls

Alias of `colorBlue45`
 */
const colorBorderInteractive = "hsl(200, 82%, 42%)";

/**
`colorBorderInteractiveHover`

Use for border-color on hover state of interactive controls

Alias of `colorBlue55`
 */
const colorBorderInteractiveHover = "hsl(200, 100%, 33%)";

/**
`colorBorderInteractiveFocus`

Use for border-color on focus state of interactive controls

Alias of `colorBlue55`
 */
const colorBorderInteractiveFocus = "hsl(200, 100%, 33%)";

/**
`colorBorderInteractiveActive`

Use for border-color on active state of interactive controls

Alias of `colorBlue65`
 */
const colorBorderInteractiveActive = "hsl(200, 98%, 26%)";

/**
`colorOutlineFocus`

Use for outline-color on interactive controls

Alias of `colorBlue55`
 */
const colorOutlineFocus = "hsl(200, 100%, 33%)";

/**
`colorOutlineFocusOnDark`

Use for outline-color on interactive controls on dark backgrounds

Alias of `colorWhite`
 */
const colorOutlineFocusOnDark = "hsl(0, 0%, 100%)";

/**
`colorTextInteractive`

Use for text color on interactive components

Alias of `colorBlue55`
 */
const colorTextInteractive = "hsl(200, 100%, 33%)";

/**
`colorTextInteractiveHover`

Use for text color on hover state of interactive components

Alias of `colorBlue65`
 */
const colorTextInteractiveHover = "hsl(200, 98%, 26%)";

/**
`colorTextInteractiveFocus`

Use for text color on focus state of interactive components

Alias of `colorBlue65`
 */
const colorTextInteractiveFocus = "hsl(200, 98%, 26%)";

/**
`colorTextInteractiveActive`

Use for text color on active state of interactive components

Alias of `colorBlue65`
 */
const colorTextInteractiveActive = "hsl(200, 98%, 26%)";

/**
`colorBackgroundReadonly`

Use for background-color on readonly components

Alias of `colorInk95`
 */
const colorBackgroundReadonly = "hsl(0, 0%, 96%)";

/**
`colorBorderReadonly`

Use for border-color on readonly components

Alias of `colorInk80`
 */
const colorBorderReadonly = "hsl(0, 0%, 83%)";

/**
`colorTextReadonly`

Use for text color on readonly components

Alias of `colorInk40`
 */
const colorTextReadonly = "hsl(0, 0%, 43%)";

/**
`colorShadow`

Use for box-shadow color. Derived from `colorGray95` with 9% opacity.
 */
const colorShadow = "hsla(0, 0%, 7%, 0.09)";

/**
`colorShadowOnDark`

Use for box-shadow color on dark backgrounds. Derived from `colorBlue75` with 39% opacity
 */
const colorShadowOnDark = "hsla(200, 98%, 18%, 0.39)";

/**
`colorInnerShadow`

Use for inner shadow color. Derived from `colorGray95` with 25% opacity.
 */
const colorInnerShadow = "hsla(0, 0%, 7%, 0.25)";

/**
`colorBackgroundStatusInformational`

Use for background-color on status components providing information

Alias of `colorBlue05`
 */
const colorBackgroundStatusInformational = "hsl(201, 100%, 96%)";

/**
`colorBackgroundStatusSuccess`

Use for background-color on status components indicating success

Alias of `colorGreen05`
 */
const colorBackgroundStatusSuccess = "hsl(108, 80%, 94%)";

/**
`colorBackgroundStatusWarning`

Use for background-color on status components indicating warning

Alias of `colorYellow05`
 */
const colorBackgroundStatusWarning = "hsl(46, 100%, 91%)";

/**
`colorBackgroundStatusError`

Use for background-color on status components indicating error

Alias of `colorRed05`
 */
const colorBackgroundStatusError = "hsl(0, 100%, 97%)";

/**
`colorBorderStatusInformational`

Use for border-color on status components indicating success

Alias of `colorBlue45`
 */
const colorBorderStatusInformational = "hsl(200, 82%, 42%)";

/**
`colorBorderStatusSuccess`

Use for border-color on status components indicating success

Alias of `colorGreen55`
 */
const colorBorderStatusSuccess = "hsl(108, 88%, 26%)";

/**
`colorBorderStatusWarning`

Use for border-color on status components indicating success

Alias of `colorYellow25`
 */
const colorBorderStatusWarning = "hsl(44, 86%, 52%)";

/**
`colorBorderStatusError`

Use for border-color on status components indicating success

Alias of `colorRed55`
 */
const colorBorderStatusError = "hsl(359, 70%, 47%)";

/**
`colorTextPrimary`

Use for text in primary content on white or light backgrounds

Alias of `colorGray95`
 */
const colorTextPrimary = "hsl(0, 0%, 7%)";

/**
`colorTextPrimaryOnDark`

Use for text in primary content on dark background

Alias of `colorWhite`
 */
const colorTextPrimaryOnDark = "hsl(0, 0%, 100%)";

/**
`colorTextSecondary`

Use for text in secondary content on white or light backgrounds

Alias of `colorGray55`
 */
const colorTextSecondary = "hsl(0, 0%, 43%)";

/**
`colorTextSecondaryOnDark`

Use for text in secondary content on dark background

Alias of `colorGray35`
 */
const colorTextSecondaryOnDark = "hsl(0, 0%, 62%)";

/**
`colorTextPositive`

Use for text & numbers indicating positive trends

Alias of `colorGreen55`
 */
const colorTextPositive = "hsl(108, 88%, 26%)";

/**
`colorTextNegative`

Use for text & numbers indicating negative trends

Alias of `colorRed55`
 */
const colorTextNegative = "hsl(359, 70%, 47%)";

/**
`colorGreenToRedStart`

OMNI Rating Color Scale -- greenToRed, use as the start color of the scale
 */
const colorGreenToRedStart = "hsl(108, 60%, 55%)";

/**
`colorGreenToRedStep2`

OMNI Rating Color Scale -- greenToRed, use as the second color of the scale
 */
const colorGreenToRedStep2 = "hsl(44, 86%, 52%)";

/**
`colorGreenToRedStep3`

OMNI Rating Color Scale -- greenToRed, use as the third color of the scale
 */
const colorGreenToRedStep3 = "hsl(35, 86%, 49%)";

/**
`colorGreenToRedEnd`

OMNI Rating Color Scale -- greenToRed, use as the third color of the scale
 */
const colorGreenToRedEnd = "hsl(35, 86%, 49%)";

/**
`colorSchemeGreenToRedSteps2`

color scale: greenToRed

Values:

```js
const values = [
  "hsl(108, 60%, 55%)",
  "hsl(359, 70%, 47%)"
]
```
 */
const colorSchemeGreenToRedSteps2 = ["hsl(108, 60%, 55%)", "hsl(359, 70%, 47%)"];

/**
`colorSchemeGreenToRedSteps3`

color scale: greenToRed

Values:

```js
const values = [
  "hsl(108, 60%, 55%)",
  "hsl(44, 86%, 52%)",
  "hsl(359, 70%, 47%)"
]
```
 */
const colorSchemeGreenToRedSteps3 = ["hsl(108, 60%, 55%)", "hsl(44, 86%, 52%)", "hsl(359, 70%, 47%)"];

/**
`colorSchemeGreenToRedSteps4`

color scale: greenToRed

Values:

```js
const values = [
  "hsl(108, 60%, 55%)",
  "hsl(44, 86%, 52%)",
  "hsl(35, 86%, 49%)",
  "hsl(359, 70%, 47%)"
]
```
 */
const colorSchemeGreenToRedSteps4 = ["hsl(108, 60%, 55%)", "hsl(44, 86%, 52%)", "hsl(35, 86%, 49%)", "hsl(359, 70%, 47%)"];

export { border1pxDotted, border1pxSolid, border2pxSolid, border4pxSolid, borderRadiusCircle, borderRadiusFull, borderRadiusGiant, borderRadiusLarge, borderRadiusMedium, borderRadiusNone, borderRadiusPill, borderRadiusSmall, borderRadiusTiny, borderRadiusZero, boxShadowBottomMedium, boxShadowBottomMediumOnDark, boxShadowLeftTiny, boxShadowMedium, boxShadowMediumOnDark, boxShadowRightTiny, boxShadowSmall, boxShadowSmallOnDark, boxShadowStickyFooter, boxShadowStickyHeader, boxShadowTiny, boxShadowTinyOnDark, boxShadowTopMedium, boxShadowTopMediumOnDark, colorAccentBlue25, colorAccentBlue30, colorAccentBlue35, colorAccentBlue60, colorAccentBlue95, colorAccentGreen25, colorAccentGreen90, colorAccentOrange50, colorAccentRed40, colorAccentRed45, colorAccentRed95, colorAccentYellow50, colorAccentYellow90, colorBackgroundDark, colorBackgroundDisabled, colorBackgroundHighlighted, colorBackgroundInput, colorBackgroundInteractiveActive, colorBackgroundInteractiveActiveOnDark, colorBackgroundInteractiveFocus, colorBackgroundInteractiveFocusOnDark, colorBackgroundInteractiveHover, colorBackgroundInteractiveHoverOnDark, colorBackgroundLight, colorBackgroundReadonly, colorBackgroundStatusError, colorBackgroundStatusInformational, colorBackgroundStatusSuccess, colorBackgroundStatusWarning, colorBackgroundTransparent, colorBackgroundWhite, colorBlack, colorBlue05, colorBlue10, colorBlue15, colorBlue20, colorBlue25, colorBlue35, colorBlue45, colorBlue55, colorBlue65, colorBlue75, colorBlue80, colorBlue90, colorBlue95, colorBorderDisabled, colorBorderDisabledOnDark, colorBorderError, colorBorderErrorActive, colorBorderErrorFocus, colorBorderErrorHover, colorBorderInput, colorBorderInputActive, colorBorderInputChecked, colorBorderInputFocus, colorBorderInputHover, colorBorderInteractive, colorBorderInteractiveActive, colorBorderInteractiveFocus, colorBorderInteractiveHover, colorBorderPrimary, colorBorderPrimaryOnDark, colorBorderReadonly, colorBorderSecondary, colorBorderSecondaryOnDark, colorBorderStatusError, colorBorderStatusInformational, colorBorderStatusSuccess, colorBorderStatusWarning, colorCommercialBlue20, colorGray05, colorGray10, colorGray15, colorGray20, colorGray25, colorGray35, colorGray45, colorGray55, colorGray65, colorGray75, colorGray80, colorGray85, colorGray90, colorGray95, colorGreen05, colorGreen10, colorGreen15, colorGreen20, colorGreen25, colorGreen35, colorGreen45, colorGreen55, colorGreen65, colorGreen75, colorGreen80, colorGreen85, colorGreen90, colorGreen95, colorGreenToRedEnd, colorGreenToRedStart, colorGreenToRedStep2, colorGreenToRedStep3, colorIconNegative, colorIconPositive, colorIconPrimary, colorIconPrimaryOnDark, colorIconSecondary, colorIconSecondaryOnDark, colorIconSelectArrowPrimary, colorIconStatusError, colorIconStatusInformational, colorIconStatusSuccess, colorIconStatusWarning, colorInk10, colorInk30, colorInk40, colorInk60, colorInk80, colorInk90, colorInk95, colorInnerShadow, colorOutlineFocus, colorOutlineFocusOnDark, colorPurple35, colorPurple55, colorRed05, colorRed10, colorRed15, colorRed20, colorRed25, colorRed35, colorRed45, colorRed55, colorRed65, colorRed75, colorRed80, colorRed85, colorRed90, colorRed95, colorSchemeGreenToRedSteps2, colorSchemeGreenToRedSteps3, colorSchemeGreenToRedSteps4, colorShadow, colorShadowOnDark, colorTextDisabled, colorTextDisabledOnDark, colorTextError, colorTextErrorActive, colorTextErrorFocus, colorTextErrorHover, colorTextInput, colorTextInputIcons, colorTextInputPlaceholder, colorTextInteractive, colorTextInteractiveActive, colorTextInteractiveFocus, colorTextInteractiveHover, colorTextNegative, colorTextPositive, colorTextPrimary, colorTextPrimaryOnDark, colorTextReadonly, colorTextSecondary, colorTextSecondaryOnDark, colorWhite, colorYellow05, colorYellow10, colorYellow15, colorYellow20, colorYellow25, colorYellow35, colorYellow45, colorYellow55, colorYellow65, colorYellow75, colorYellow80, colorYellow85, colorYellow90, colorYellow95, easingEntranceExpressive, easingEntrancePurposeful, easingExitExpressive, easingExitPurposeful, easingStandardExpressive, easingStandardPurposeful, fontFaceOptimistBold, fontFaceOptimistBoldItalic, fontFaceOptimistExtraLight, fontFaceOptimistExtraLightItalic, fontFaceOptimistLight, fontFaceOptimistLightItalic, fontFaceOptimistRegular, fontFaceOptimistRegularItalic, fontFaceOptimistSemiBold, fontFaceOptimistSemiBoldItalic, fontFamilyCode, fontFamilyLegacy, fontFamilyOptimist, fontFamilySystem, fontSizeBodyHuge, fontSizeBodyLarge, fontSizeBodyMedium, fontSizeBodySmall, fontSizeBodyTiny, fontSizeHeadingHuge, fontSizeHeadingLarge, fontSizeHeadingMedium, fontSizeHeadingSmall, fontSizeHeadingTiny, fontSizeMetricHuge, fontSizeMetricLarge, fontSizeTitleGiant, fontSizeTitleHuge, fontSizeTitleLarge, fontSizeTitleMedium, fontWeight200ExtraLight, fontWeight300Light, fontWeight400Regular, fontWeight600SemiBold, fontWeight700Bold, heightFull, letterSpacingDefault, letterSpacingEyebrowPrimary, letterSpacingEyebrowSecondary, lineHeight075, lineHeight0875, lineHeight1, lineHeight125, lineHeight133, lineHeight1375, lineHeight150, lineHeight1625, lineHeight175, lineHeight2, lineHeightBodyHuge, lineHeightBodyLarge, lineHeightBodyMedium, lineHeightBodySmall, lineHeightBodyTiny, lineHeightButton, lineHeightHeadingHuge, lineHeightHeadingLarge, lineHeightHeadingMedium, lineHeightHeadingSmall, lineHeightHeadingTiny, lineHeightInput, lineHeightMetricHuge, lineHeightMetricLarge, lineHeightTableCell, lineHeightTitleGiant, lineHeightTitleHuge, lineHeightTitleLarge, lineHeightTitleMedium, lineLengthHuge, lineLengthLarge, lineLengthMedium, lineLengthSmall, lineLengthTiny, mediaQueryHuge1800AndUp, mediaQueryLarge1200AndUp, mediaQueryLarge1200To1799, mediaQueryMedium900AndUp, mediaQueryMedium900To1199, mediaQuerySmall600AndUp, mediaQuerySmall600To899, mediaQueryTiny599AndDown, negativeMarginGiant, negativeMarginHuge, negativeMarginLarge, negativeMarginMedium, negativeMarginSmall, negativeMarginTiny, opacity0, opacity100, opacity5, opacity95, outlineDisabled, outlineInteractive, spacingGiant, spacingHuge, spacingLarge, spacingMedium, spacingSmall, spacingTiny, spacingZero, widthFull, widthHalf, widthQuarter, zIndex0, zIndex100, zIndex200, zIndex300 };
